module.exports = __webpack_public_path__ + "static/media/people-search.4e594bbf.svg";